import React from 'react';

class LabelCardComponent extends React.Component {

  handleClick(e) {
    e.preventDefault();
    const { id, parentLabel, handleSelectedRoute } = this.props;
    handleSelectedRoute(id, parentLabel);
  }

  render() {
    const labelShortType = this.props.labelType ?
      this.props.labelType.charAt(0).toUpperCase() :
      null;

    return (
      <div className="Grid-cell-sm1">
        <div id={this.props.id} className="EntityCard" onClick={this.handleClick.bind(this)}>
          <div className="EntityCard-Identifier--left">{labelShortType}</div>
          <div className="EntityCard-Content">
            {this.props.name}
            <div className="EntityCard-Details">
              <span className="EntityCard-Details--left"></span>
              <span className="EntityCard-Details--right"></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LabelCardComponent;



// WEBPACK FOOTER //
// ./src/components/labelViewer/details/labelCard.jsx